import axios from 'axios';
import ConstantApi from '../../../../ConstantApi';
import axiosCall from '../../../axiosCall';
import { fetchPartyDetailsData } from '../../../partyDetails/partyDetails.action';
import { fetchCommonPropertyById } from '../../../property/common/commonProperty.actions';
import { fetchSeasonMaster } from '../../../seasonMaster/seasonMaster.actions';
import { fetchUnitMaster } from '../../../unitMaster/unitMaster.actions';
import {
    fetchSupplierListBasedOnProgramDC,
    fetchYarnPOProgramDropdown,
    fetchYarnPOSalesOrderDropdown,
    getYarnPOInvoiceData
} from '../../YarnPO/yarnPO/yarnPO.actions';

import {
    CREATE_STITCHING_DC_FAILURE,
    CREATE_STITCHING_DC_REQUEST,
    CREATE_STITCHING_DC_SUCCESS,
    CREATE_USER_FORM_STITCHING_DC,
    DELETE_STITCHING_DC_FAILURE,
    DELETE_STITCHING_DC_REQUEST,
    DELETE_STITCHING_DC_SUCCESS,
    FETCH_SINGLE_STITCHING_DC_FAILURE,
    FETCH_SINGLE_STITCHING_DC_REQUEST,
    FETCH_SINGLE_STITCHING_DC_SUCCESS,
    FETCH_STITCHING_DC_FAILURE,
    FETCH_STITCHING_DC_REQUEST,
    FETCH_STITCHING_DC_SUCCESS,
    STITCHING_DC_USERFORM_RESET,
    UPDATE_STITCHING_DC_FAILURE,
    UPDATE_STITCHING_DC_REQUEST,
    UPDATE_STITCHING_DC_SUCCESS,
    STITCHING_DC_USERFORM_NAVIGATE_TO_DETAIL_TAB,
    FETCH_YARN_PO_IN_STITCHING_DC_REQUEST,
    FETCH_YARN_PO_IN_STITCHING_DC_SUCCESS,
    FETCH_YARN_PO_IN_STITCHING_DC_FAILURE,
    FETCH_STITCHING_DC_INVOICE_REQUEST,
    FETCH_STITCHING_DC_INVOICE_SUCCESS,
    FETCH_STITCHING_DC_INVOICE_FAILURE,
    FETCH_STITCHING_DC_ACCESSORIES_REQUEST,
    FETCH_STITCHING_DC_ACCESSORIES_SUCCESS,
    FETCH_STITCHING_DC_ACCESSORIES_FAILURE,
    FETCH_STITCHING_DC_BARCODE_REQUEST,
    FETCH_STITCHING_DC_BARCODE_SUCCESS,
    FETCH_STITCHING_DC_BARCODE_FAILURE,
    STITCHING_SUPPLIER_UPDATE_REQUEST,
    STITCHING_SUPPLIER_UPDATE_SUCCESS,
    STITCHING_SUPPLIER_UPDATE_FAILURE,
    FETCH_STITCHING_DC_PRINT_BARCODE_REQUEST,
    FETCH_STITCHING_DC_PRINT_BARCODE_SUCCESS,
    FETCH_STITCHING_DC_PRINT_BARCODE_FAILURE,
    FETCH_FOLDING_FABRIC_IN_STITCHING_DC_PRINT_REQUEST,
    FETCH_FOLDING_FABRIC_IN_STITCHING_DC_PRINT_SUCCESS,
    FETCH_FOLDING_FABRIC_IN_STITCHING_DC_PRINT_FAILURE,
    FETCH_IN_STITCHING_DC_REPORTS_REQUEST,
    FETCH_IN_STITCHING_DC_REPORTS_SUCCESS,
    FETCH_IN_STITCHING_DC_REPORTS_FAILURE,
    FETCH_IN_STITCHING_DC_REPORTS_PRODUCTION_REQUEST,
    FETCH_IN_STITCHING_DC_REPORTS_PRODUCTION_SUCCESS,
    FETCH_IN_STITCHING_DC_REPORTS_PRODUCTION_FAILURE,
} from './stitchingDC.actionsType';

// FETCH PROPERTY MASTER
export let fetchStitchingDC = (startDate, endDate, unitId) => {
    let config = {
        method: 'get',
        // url: `${ConstantApi.stitchingDCMasterGET}`,
        url: `${ConstantApi.stitchingDCMasterGET}?FldFKUnitId=${-1}&FldFromDate=${startDate}&FldToDate=${endDate}`,
        responseTypeRequest: FETCH_STITCHING_DC_REQUEST,
        responseTypeSuccess: FETCH_STITCHING_DC_SUCCESS,
        responseTypeFailure: FETCH_STITCHING_DC_FAILURE
    };
    return axiosCall(config);
};

// create user Form
export let createStitchingDCUserForm = (key, value) => {
    return (dispatch) => {
        dispatch({ type: CREATE_USER_FORM_STITCHING_DC, payload: { key, value } });
    };
};

// CREATE PROPERTY MASTER
export let createStitchingDC = (formData, modalClose, startDate, endDate, empty, unitId, isDetail) => {
    let today = new Date();
    let data = JSON.stringify({
        fldId: 0,
        fldFKSupplierID: parseInt(formData.fldFKSupplierID),
        fldFKTypeofPO: parseInt(formData.fldFKTypeofPO),
        fldFKSource: parseInt(formData.fldFKSource),
        fldFKSeason: parseInt(formData.fldFKSeason),
        fldFKDepartment: parseInt(formData.fldFKDepartment),
        fldFKSaleOrderdetail: parseInt(formData.fldFKSaleOrderdetail),
        fldDCNo: 'Auto Generated',
        fldDCDate: today.toISOString(),
        fldDeliveryStartDate: formData.fldDeliveryStartDate || today.toISOString(),
        fldDeliveryEndDate: formData.fldDeliveryEndDate || today.toISOString(),
        fldIsInHouseDelivery: formData.fldIsInHouseDelivery,
        // fldFKDeliveryAt: formData.fldIsInHouseDelivery ? 0 : parseInt(formData.fldFKDeliveryAt),
        fldFKDeliveryAt: parseInt(formData.fldFKDeliveryAt),
        fldIsInHouseProduction: formData.fldIsInHouseProduction,
        fldNoofBags: Number(formData.fldNoofBags),
        fldTotalQty: Number(formData.fldTotalQty),
        fldInwardQty: 0,
        fldCancelQty: 0,
        fldBalanceQty: 0,
        fldPreparedBy: '',
        fldPrepareDate: null,
        fldVerifyBy: '',
        fldVerifyDate: null,
        fldAuthorizeBy: '',
        fldAuthorizeDate: null,
        // fldPreparedBy: '',
        // fldPrepareDate: today.toISOString(),
        // fldVerifyBy: '',
        // fldVerifyDate: today.toISOString(),
        // fldAuthorizeBy: '',
        // fldAuthorizeDate: today.toISOString(),
        fldInwardBy: '',
        fldInwardDate: null,
        fldRemarks: formData.fldRemarks,
        fldIsActive: true,
        fldEnteredSysId: formData.ipv4,
        fldCreatedBy: 11,
        fldCreatedDt: today.toISOString(),
        fldFKStatus: formData.fldFKStatus,
        fldFKUnitId: parseInt(formData.fldFKUnitId),
        fldFKSection: parseInt(formData.fldFKSection),
        fldFKProgram: parseInt(formData.fldFKProgram),
        fldApprovalStatus: 0,
        fldUnitCode: '',
        fldUnitName: '',
        fldUnitAddress1: '',
        fldUnitAddress2: '',
        fldUnitFKArea: 0,
        fldUnitCountry: '',
        fldUnitState: '',
        fldUnitCity: '',
        fldUnitArea: '',
        fldUnitPincode: '',
        fldUnitGSTNo: '',
        fldSupplierCode: '',
        fldSupplierName: '',
        fldSupplierAddress1: '',
        fldSupplierAddress2: '',
        fldSupplierFKArea: 0,
        fldSupplierCountry: '',
        fldSupplierState: '',
        fldSupplierCity: '',
        fldSupplierArea: '',
        fldSupplierPincode: '',
        fldSupplierGSTNo: '',
        fldDeliveryAtCode: '',
        fldDeliveryAtName: '',
        fldDeliveryAtAddress1: '',
        fldDeliveryAtAddress2: '',
        fldDeliveryAtFKArea: 0,
        fldDeliveryAtCountry: '',
        fldDeliveryAtState: '',
        fldDeliveryAtCity: '',
        fldDeliveryAtArea: '',
        fldDeliveryAtPincode: '',
        fldDeliveryAtGSTNo: '',
        fldFKSaleOrder: parseInt(formData.fldFKSaleOrder),
        fldFKStyle: parseInt(formData.fldFKStyle),
        fldItemsGrossValue: Number(formData.fldItemsGrossValue),
        fldItemsTaxableValue: Number(formData.fldItemsTaxableValue),
        fldItemsGSTValue: Number(formData.fldItemsGSTValue),
        fldItemsTotalValue: Number(formData.fldItemsTotalValue),
        fldDiscountPercentage: Number(formData.fldDiscountPercentage),
        fldDiscountValue: Number(formData.fldDiscountValue),
        fldGrandGrossValue: Number(formData.fldGrandGrossValue),
        fldOtherPlusValue: Number(formData.fldOtherPlusValue),
        fldOtherMinusValue: Number(formData.fldOtherMinusValue),
        fldRoundoff: Number(formData.fldRoundoff),
        fldGrandTotalValue: Number(formData.fldGrandTotalValue),
        fldFKPaymentTerms: parseInt(formData.fldFKPaymentTerms),
        fldIsUnit: formData.fldIsUnit

    });
    let config = {
        method: 'post',
        data,
        url: `${ConstantApi.stitchingDCMasterPOST}`,
        responseTypeRequest: CREATE_STITCHING_DC_REQUEST,
        responseTypeSuccess: CREATE_STITCHING_DC_SUCCESS,
        responseTypeFailure: CREATE_STITCHING_DC_FAILURE,
        resetFormData: isDetail ? STITCHING_DC_USERFORM_NAVIGATE_TO_DETAIL_TAB : STITCHING_DC_USERFORM_RESET,
        modalClose,
        PoDcInwardNo: 'fldPONO',
        PoDcInwardType: 'DC',
        isPopupOpen: true,
        headers: {
            'Content-Type': 'application/json'
        },
        getAllData: fetchStitchingDC(startDate, endDate, unitId)
    };
    return axiosCall(config);
};

// GET SINGLE PROPERTY MASTER
export let getSingleStitchingDC = (id) => {
    let config = {
        method: 'get',
        url: `${ConstantApi.stitchingDCMasterGETID}/${id}`,
        responseTypeRequest: FETCH_SINGLE_STITCHING_DC_REQUEST,
        responseTypeSuccess: FETCH_SINGLE_STITCHING_DC_SUCCESS,
        responseTypeFailure: FETCH_SINGLE_STITCHING_DC_FAILURE,
        singlApiArray: [
            fetchSeasonMaster(),
            fetchPartyDetailsData(),
            fetchCommonPropertyById(52),
            fetchCommonPropertyById(46),
            fetchCommonPropertyById(28),
            fetchUnitMaster(),
            fetchYarnPOProgramDropdown('TblStitchingDC'),
            fetchSupplierListBasedOnProgramDC('TblStitchingDC')
        ]
    };
    return axiosCall(config);
};

export let getStitchingDCInvoiceDataV2 = (id) => {
    let config = {
        method: 'get',
        url: `${ConstantApi.stitchingDCInvoiceGET}/${id}`,
        responseTypeRequest: FETCH_STITCHING_DC_INVOICE_REQUEST,
        responseTypeSuccess: FETCH_STITCHING_DC_INVOICE_SUCCESS,
        responseTypeFailure: FETCH_STITCHING_DC_INVOICE_FAILURE
    };
    return axiosCall(config);
};
export let getStitchingAccessoriesData = (id) => {
    let config = {
        method: 'get',
        url: `${ConstantApi.stitchingDCAccessGET}/${id}`,
        responseTypeRequest: FETCH_STITCHING_DC_ACCESSORIES_REQUEST,
        responseTypeSuccess: FETCH_STITCHING_DC_ACCESSORIES_SUCCESS,
        responseTypeFailure: FETCH_STITCHING_DC_ACCESSORIES_FAILURE,
    };
    return axiosCall(config);
};
export let getStitchingBarcodeData = (id) => {
    let config = {
        method: 'get',
        url: `${ConstantApi.stitchingDCBarcodeeGET}?FldFKDCNo=${id}`,
        responseTypeRequest: FETCH_STITCHING_DC_BARCODE_REQUEST,
        responseTypeSuccess: FETCH_STITCHING_DC_BARCODE_SUCCESS,
        responseTypeFailure: FETCH_STITCHING_DC_BARCODE_FAILURE,
    };
    return axiosCall(config);
};


export let getStitchingBarcodePrintData = (id) => {
    let config = {
        method: 'get',
        url: `${ConstantApi.stitchingDCBarcodeePrintGET}?FldFKDCNo=${id}`,
        responseTypeRequest: FETCH_STITCHING_DC_PRINT_BARCODE_REQUEST,
        responseTypeSuccess: FETCH_STITCHING_DC_PRINT_BARCODE_SUCCESS,
        responseTypeFailure: FETCH_STITCHING_DC_PRINT_BARCODE_FAILURE,
    };
    return axiosCall(config);
};


//UPDATE PROPERTY MASTER
export let updateStitchingDC = (formData, id, startDate, endDate, unitId, supplierUpdateID) => {
    let today = new Date();
    let data = JSON.stringify({
        fldId: parseInt(id),
        fldFKSupplierID: parseInt(formData.fldFKSupplierID),
        fldFKTypeofPO: parseInt(formData.fldFKTypeofPO),
        fldFKSource: parseInt(formData.fldFKSource),
        fldFKSeason: parseInt(formData.fldFKSeason),
        fldFKDepartment: parseInt(formData.fldFKDepartment),
        fldDCNo: formData?.fldDCNo,
        fldDCDate: formData?.fldDCDate,
        fldDeliveryStartDate: formData.fldDeliveryStartDate,
        fldFKSaleOrderdetail: parseInt(formData.fldFKSaleOrderdetail),
        fldIsInHouseProduction: formData.fldIsInHouseProduction,
        fldDeliveryEndDate: formData.fldDeliveryEndDate,
        fldIsInHouseDelivery: formData.fldIsInHouseDelivery,
        // fldFKDeliveryAt: formData.fldIsInHouseDelivery ? 0 : parseInt(formData.fldFKDeliveryAt),
        fldFKDeliveryAt: parseInt(formData.fldFKDeliveryAt),
        fldNoofBags: parseInt(formData.fldNoofBags),
        fldTotalQty: parseInt(formData.fldTotalQty),
        fldInwardQty: formData?.fldInwardQty,
        fldCancelQty: formData?.fldCancelQty,
        fldBalanceQty: formData?.fldBalanceQty,

        fldPreparedBy: formData.fldPreparedBy,
        fldPrepareDate: formData.fldPrepareDate || null,
        fldVerifyBy: formData.fldVerifyBy,
        fldVerifyDate: formData.fldVerifyDate || null,
        fldAuthorizeBy: formData.fldAuthorizeBy,
        fldAuthorizeDate: formData.fldAuthorizeDate || null,

        // fldVerifyBy: '',
        // fldVerifyDate: today.toISOString(),
        // fldAuthorizeBy: '',
        // fldAuthorizeDate: today.toISOString(),
        fldInwardBy: formData.fldInwardBy || '',
        fldInwardDate: formData.fldInwardDate || null,
        fldRemarks: formData.fldRemarks,
        fldIsActive: true,
        fldEnteredSysId: formData.ipv4,
        fldCreatedBy: formData.fldCreatedBy,
        fldCreatedDt: formData.fldCreatedDt,
        // fldPreparedBy: formData.fldPreparedBy,
        // fldPrepareDate: formData.fldPrepareDate,
        fldIsPrepared: formData.fldIsPrepared,
        fldIsVerified: formData.fldIsVerified,
        fldIsAuthorized: formData.fldIsAuthorized,

        fldModifiedBy: 11,
        fldModifiedDt: today.toISOString(),
        fldFKStatus: formData.fldFKStatus,
        fldFKUnitId: parseInt(formData.fldFKUnitId),
        fldFKSection: parseInt(formData.fldFKSection),
        fldFKProgram: parseInt(formData.fldFKProgram),
        fldApprovalStatus: 0,
        fldUnitCode: '',
        fldUnitName: '',
        fldUnitAddress1: '',
        fldUnitAddress2: '',
        fldUnitFKArea: 0,
        fldUnitCountry: '',
        fldUnitState: '',
        fldUnitCity: '',
        fldUnitArea: '',
        fldUnitPincode: '',
        fldUnitGSTNo: '',
        fldSupplierCode: '',
        fldSupplierName: '',
        fldSupplierAddress1: '',
        fldSupplierAddress2: '',
        fldSupplierFKArea: 0,
        fldSupplierCountry: '',
        fldSupplierState: '',
        fldSupplierCity: '',
        fldSupplierArea: '',
        fldSupplierPincode: '',
        fldSupplierGSTNo: '',
        fldDeliveryAtCode: '',
        fldDeliveryAtName: '',
        fldDeliveryAtAddress1: '',
        fldDeliveryAtAddress2: '',
        fldDeliveryAtFKArea: 0,
        fldDeliveryAtCountry: '',
        fldDeliveryAtState: '',
        fldDeliveryAtCity: '',
        fldDeliveryAtArea: '',
        fldDeliveryAtPincode: '',
        fldDeliveryAtGSTNo: '',
        fldFKSaleOrder: parseInt(formData.fldFKSaleOrder),
        fldFKStyle: parseInt(formData.fldFKStyle),

        // fldItemsGrossValue: Number(formData.fldItemsGrossValue),
        // fldItemsTaxableValue: Number(formData.fldItemsTaxableValue),
        // fldItemsGSTValue: Number(formData.fldItemsGSTValue),
        // fldItemsTotalValue: Number(formData.fldItemsTotalValue),
        // fldDiscountPercentage: Number(formData.fldDiscountPercentage),
        // fldDiscountValue: Number(formData.fldDiscountValue),
        // fldGrandGrossValue: Number(formData.fldGrandGrossValue),
        // fldOtherPlusValue: Number(formData.fldOtherPlusValue),
        // fldOtherMinusValue: Number(formData.fldOtherMinusValue),
        // fldRoundoff: Number(formData.fldRoundoff),
        // fldGrandTotalValue: Number(formData.fldGrandTotalValue),

        fldItemsGrossValue: formData.fldItemsGrossValue ? Number(formData.fldItemsGrossValue) : 0,
        fldItemsTaxableValue: formData.fldItemsTaxableValue ? Number(formData.fldItemsTaxableValue) : 0,
        fldItemsGSTValue: formData.fldItemsGSTValue ? Number(formData.fldItemsGSTValue) : 0,
        fldItemsTotalValue: formData.fldItemsTotalValue ? Number(formData.fldItemsTotalValue) : 0,
        fldDiscountPercentage: formData.fldDiscountPercentage ? Number(formData.fldDiscountPercentage) : 0,
        fldDiscountValue: formData.fldDiscountValue ? Number(formData.fldDiscountValue) : 0,
        fldGrandGrossValue: formData.fldGrandGrossValue ? Number(formData.fldGrandGrossValue) : 0,
        fldOtherPlusValue: formData.fldOtherPlusValue ? Number(formData.fldOtherPlusValue) : 0,
        fldOtherMinusValue: formData.fldOtherMinusValue ? Number(formData.fldOtherMinusValue) : 0,
        fldRoundoff: formData.fldRoundoff ? Number(formData.fldRoundoff) : 0,
        fldGrandTotalValue: formData.fldGrandTotalValue ? Number(formData.fldGrandTotalValue) : 0,
        fldIsUnit: formData.fldIsUnit,
        FldFKPaymentTerms: parseInt(formData.fldFKPaymentTerms),
    });
    let config = {
        method: 'patch',
        data,
        url: `${ConstantApi.stitchingDCMasterPATCH}/${id}`,
        responseTypeRequest: UPDATE_STITCHING_DC_REQUEST,
        responseTypeSuccess: UPDATE_STITCHING_DC_SUCCESS,
        responseTypeFailure: UPDATE_STITCHING_DC_FAILURE,
        resetFormData: STITCHING_DC_USERFORM_RESET,
        modalClose: true,
        headers: {
            'Content-Type': 'application/json'
        },
        // getAllData: fetchStitchingDC(startDate, endDate, unitId)

        singlApiArray: [
            fetchStitchingDC(startDate, endDate, unitId),
            postSuplierUpdateStitching(supplierUpdateID)
        ]
    };
    return axiosCall(config);
};

// DELETE PROPERTY MASTER
export let deleteStitchingDC = (id, startDate, endDate, unitId) => {
    let config = {
        method: 'delete',
        url: `${ConstantApi.stitchingDCMasterDELETE}/${id}`,
        responseTypeRequest: DELETE_STITCHING_DC_REQUEST,
        responseTypeSuccess: DELETE_STITCHING_DC_SUCCESS,
        responseTypeFailure: DELETE_STITCHING_DC_FAILURE,
        modalClose: true,
        getAllData: fetchStitchingDC(startDate, endDate, unitId)
    };
    return axiosCall(config);
};

// FETCH PROPERTY MASTER
export let fetchYarnPOOfPoNo = () => {
    let config = {
        method: 'get',
        url: `${ConstantApi.stitchingDCMasterOfYarnPOGET}`,
        responseTypeRequest: FETCH_YARN_PO_IN_STITCHING_DC_REQUEST,
        responseTypeSuccess: FETCH_YARN_PO_IN_STITCHING_DC_SUCCESS,
        responseTypeFailure: FETCH_YARN_PO_IN_STITCHING_DC_FAILURE
    };
    return axiosCall(config);
};

export let postSuplierUpdateStitching = (id) => {
    let config = {
        method: 'patch',
        url: `${ConstantApi.stitchingSupplierUpdatePost}?FldId=${id}`,
        responseTypeRequest: STITCHING_SUPPLIER_UPDATE_REQUEST,
        responseTypeSuccess: STITCHING_SUPPLIER_UPDATE_SUCCESS,
        responseTypeFailure: STITCHING_SUPPLIER_UPDATE_FAILURE
    };
    return axiosCall(config);
};

export let fetchFoldingFabricPrint = (id) => {
    let config = {
        method: 'get',
        url: `${ConstantApi.foldingFabricPrint}/${id}`,
        responseTypeRequest: FETCH_FOLDING_FABRIC_IN_STITCHING_DC_PRINT_REQUEST,
        responseTypeSuccess: FETCH_FOLDING_FABRIC_IN_STITCHING_DC_PRINT_SUCCESS,
        responseTypeFailure: FETCH_FOLDING_FABRIC_IN_STITCHING_DC_PRINT_FAILURE
    };
    return axiosCall(config);
};


export let fetchStitchingReports = (action, startDate, endDate, id) => {
    let config = {
        method: 'get',
        url: `${ConstantApi.getStitchingReports}?Action=${action}&FrDate=${startDate}&ToDate=${endDate}&FldStyleId=${id}`,
        responseTypeRequest: FETCH_IN_STITCHING_DC_REPORTS_REQUEST,
        responseTypeSuccess: FETCH_IN_STITCHING_DC_REPORTS_SUCCESS,
        responseTypeFailure: FETCH_IN_STITCHING_DC_REPORTS_FAILURE
    };
    return axiosCall(config);
};

export let fetchStitchingReportsProduction = (action, startDate, endDate) => {
    let config = {
        method: 'get',
        url: `${ConstantApi.getStitchingReports}?Action=${action}&FrDate=${startDate}&ToDate=${endDate}&FldStyleId=0`,
        responseTypeRequest: FETCH_IN_STITCHING_DC_REPORTS_PRODUCTION_REQUEST,
        responseTypeSuccess: FETCH_IN_STITCHING_DC_REPORTS_PRODUCTION_SUCCESS,
        responseTypeFailure: FETCH_IN_STITCHING_DC_REPORTS_PRODUCTION_FAILURE
    };
    return axiosCall(config);
};